import { useEffect, useRef } from 'react';

import { BackHandler, NativeEventSubscription } from 'react-native';

import { isWeb } from 'utils/responsiveness.ts';

function useBackHandler(callback: () => boolean | null | undefined) {
    const subscription = useRef<NativeEventSubscription | undefined>(undefined);

    useEffect(() => {
        if (!isWeb) {
            subscription.current = BackHandler.addEventListener(
                'hardwareBackPress',
                callback,
            );
        }

        return () => {
            if (!isWeb && subscription.current) {
                subscription.current.remove();
                subscription.current = undefined;
            }
        };
    }, [callback]);
}

export default useBackHandler;
